export default __webpack_public_path__ + "static/media/Atlas-800T-A2.f9d22dba.png";